<template>
  <div class="kairos-form">
    <form id="kairos-form" :action="kairosApi.url.action" method="POST" ref="kairosForm">
      <input type="hidden" name="f_item_name_last" :value="customer.name_sei" />
      <input type="hidden" name="f_item_name_first" :value="customer.name_mei" />
      <input type="hidden" name="f_item_name_kana_last" :value="customer.kana_sei" />
      <input type="hidden" name="f_item_name_kana_first" :value="customer.kana_mei" />
      <input type="hidden" name="f_item_mail" :value="customer.email" />
      <input type="hidden" name="f_item_company_name" :value="displayCareer(customer.career)" />
      <input type="hidden" name="f_item_division" :value="displayNowStatus(customer.now_status)" />
      <input type="hidden" name="f_item_title" :value="displayGender(customer.sex)" />
      <input type="hidden" name="f_item_zip" value="" />
      <input type="hidden" name="f_item_address_pref" :value="customer.pref" />
      <input type="hidden" name="f_item_address_city" :value="displayPrefName(customer.workplace)" />
      <input type="hidden" name="f_item_address_street" :value="displayBirthday(customer.birthday)" />
      <input type="hidden" name="f_item_address_bldg" value="" />
      <input type="hidden" name="f_item_tel" value="" />
      <input type="hidden" name="f_item_fax" value="" />
      <input type="hidden" name="f_item_mobile" :value="`${customer.tel1}${customer.tel2}${customer.tel3}`" />
      <input type="hidden" name="f_item_text13" :value="kairosApi.form.stopFlg" />
      <input type="hidden" name="f_item_text14" value="" />
      <input type="hidden" name="api_key" :value="kairosApi.form.apiKey" />
      <input type="hidden" name="opt" value="1" />
      <input type="hidden" name="red" :value="kairosApi.url.red" />
      <input type="hidden" name="red_error" :value="kairosApi.url.redError" />
      <input type="hidden" name="tag" :value="kairosApi.form.tag" />
    </form>
  </div>
</template>

<script>
import constMixin from '../../mixins/ConstMixin'
import Careers from '../../mixins/CareerMixin'
import nowStatuses from '../../mixins/NowStatusMixin'
import Gender from '../../mixins/GenderMixin'
import functionsMixin from '../../mixins/functionsMixin'

export default {
  name: 'FormKairos',
  mixins: [constMixin, Careers, nowStatuses, Gender, functionsMixin],
  props: {
    customer: {
      type: Object,
      required: true
    },
    doSubmit: {
      type: Boolean,
      required: true
    }
  },
  mounted: function () {
    // this.$refs.kairosForm.submit()
    // console.log(this.$refs.kairosForm)
  },
  watch: {
    doSubmit: function () {
      // console.log(this.customer)
      this.$refs.kairosForm.submit()
    }
  },
  methods: {
    displayCareer: function (career) {
      if (career === '') {
        return ''
      }
      for (let key in this.careers) {
        if (this.careers.hasOwnProperty(key)) {
          if (this.careers[key].id === career) {
            return this.careers[key].text
          }
        }
      }
    },
    displayNowStatus: function (nowStatus) {
      if (nowStatus === '') {
        return ''
      }
      for (let key in this.nowStatuses) {
        if (this.nowStatuses.hasOwnProperty(key)) {
          if (this.nowStatuses[key].id === nowStatus) {
            return this.nowStatuses[key].text
          }
        }
      }
    },
    displayBirthday: function (birthday) {
      if (birthday) {
        let bd = new Date(birthday)
        return `${bd.getFullYear()}-${this.toDoubleDigits(bd.getMonth() + 1)}-${this.toDoubleDigits(bd.getDate())}`
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.kairos-form {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/FormKairos.vue